import { PortalFilters as View } from "ui-components";

import {
	useFilters,
	useSetFilters,
	useSetSort,
	useSetView,
	useSort,
	useView,
} from "~maps-portal/states/filters";

export const Filters = () => {
	const filters = useFilters();
	const sortDir = useSort();
	const view = useView();
	const setView = useSetView();
	const setSort = useSetSort();
	const setFilters = useSetFilters();

	return (
		<View
			tab="maps"
			filters={filters}
			sortDir={sortDir}
			view={view}
			setView={setView}
			setSort={setSort}
			setFilters={setFilters}
		/>
	);
};
